export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

/** Numeric severity values for each log level, used for level-based filtering */
export const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};
